import React from 'react';
import { observer } from 'mobx-react-lite';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { useAppStateContext } from 'src/AppState/AppState';
import { OldSelect } from 'src/domains/layouts/shared/formComponents/Select/components/OldSelect';
import { racingOptions } from './sportOption';
import { ErrorMessageBar } from 'src/domains/layouts/shared/formComponents/FormComponents.style';

export const DestinanionOptionsPanel = observer((): React.ReactElement | null => {
    const { topNavigationLinkState } = useAppStateContext();
    return (
        <>
            {topNavigationLinkState.directionOption.value === 'direct-link' ? (
                <OldInput
                    label='Destination link*'
                    status={topNavigationLinkState.ctaUrlStatus}
                    formInputState={topNavigationLinkState.ctaUrl}
                    model={topNavigationLinkState.ctaUrlModel}/>
            ) : null}
            {topNavigationLinkState.directionOption.value === 'event-id' ? (
                <OldInput
                    label='Event id*'
                    status={topNavigationLinkState.eventIdStatus}
                    formInputState={topNavigationLinkState.eventId}
                    model={topNavigationLinkState.eventIdModel}/>
            ) : null}
            {topNavigationLinkState.directionOption.value === 'competition-id' ? (
                <>
                    <OldInput
                        label='Competition id*'
                        status={topNavigationLinkState.competitionIdStatus}
                        formInputState={topNavigationLinkState.competitionId}
                        model={topNavigationLinkState.competitionIdModel}/>
                    <OldSelect selectOptions={topNavigationLinkState.allSportsOptions} stateValue={topNavigationLinkState.sport} defaultText='Select sport' label='Sport*' />

                    {topNavigationLinkState.competitionIsNotFull ? (
                        <ErrorMessageBar>Both fields are reqired</ErrorMessageBar>
                    ) : null}
                </>
            ) : null}
            {topNavigationLinkState.directionOption.value === 'sport' ? (
                <OldSelect selectOptions={topNavigationLinkState.allSportsOptions} stateValue={topNavigationLinkState.sport} defaultText='Select sport' label='Sport*' dataTest='select-sport' />
            ) : null}
            {topNavigationLinkState.directionOption.value === 'next-off-race' ? (
                <>
                    <OldInput
                        label='Competition id*'
                        status={topNavigationLinkState.competitionIdStatus}
                        formInputState={topNavigationLinkState.competitionId}
                        model={topNavigationLinkState.competitionIdModel}/>
                    <OldInput
                        label='Race id*'
                        status={topNavigationLinkState.eventIdStatus}
                        formInputState={topNavigationLinkState.eventId}
                        model={topNavigationLinkState.eventIdModel}/>

                    <OldSelect selectOptions={racingOptions} defaultText='Select sport' stateValue={topNavigationLinkState.sport} label='Sport*' />

                    {topNavigationLinkState.nextOffInfoIsNotFull ? (
                        <ErrorMessageBar>Both fields are reqired</ErrorMessageBar>
                    ) : null}
                </>
            ) : null}
        </>
    );
});
